import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken } from "../../crud/auth.crud";
import * as routerHelpers from "../../router/RouterHelpers";
import { actions as builderActions } from "../../../_metronic/ducks/builder";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  Alert: "Alert Window",
  refreshStatistic: "Refresh Statistic",
  EditUser: "Edit User",
  UpdateToken: "[Update Token] Action",
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  alert: null,
  refreshStatistic: new Date(),
};

export const reducer = persistReducer(
  { storage, key: "demo1-auth", whitelist: ["user", "authToken"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Logout: {
        routerHelpers.forgotLastLocation();
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;

        return { ...state, user: user.data };
      }

      case actionTypes.Alert: {
        const { alert } = action.payload;

        return { ...state, alert: alert };
      }

      case actionTypes.refreshStatistic: {
        return { ...state, refreshStatistic: new Date() };
      }

      case actionTypes.EditUser: {
        const { firstName, lastName, email } = action.payload;
        return {
          ...state,
          user: {
            ...state.user,
            firstName: firstName,
            lastName: lastName,
            fullName: firstName + " " + lastName,
            email: email,
          },
        };
      }

      case actionTypes.UpdateToken: {
        const { authToken } = action.payload;
        return { ...state, authToken };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken) => ({ type: actionTypes.Login, payload: { authToken } }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  alert: (alert) => ({ type: actionTypes.Alert, payload: { alert } }),
  refreshStatistic: () => ({ type: actionTypes.refreshStatistic }),
  editUser: (data) => ({ type: actionTypes.EditUser, payload: { ...data } }),
  updateToken: (authToken) => ({ type: actionTypes.UpdateToken, payload: { authToken } }),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    // try {
      // console.log("[Saga] loginSaga running");
      // yield put(builderActions.setLoaderScreen(true)); // <-- Comment out
      // yield put(actions.requestUser()); // <-- Comment out
    // } finally {
      // yield put(builderActions.setLoaderScreen(false)); // <-- Comment out
    // }
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    // try {
      // console.log("[Saga] Attempting getUserByToken within userRequested saga");
      // const { data: user } = yield getUserByToken(); // <-- Comment out API call
      // console.log("[Saga] getUserByToken succeeded within userRequested saga");
      // yield put(actions.fulfillUser(user)); // <-- Comment out dispatch
    // } catch (error) {
      // console.error("[Saga] getUserByToken failed within userRequested saga:", error);
    // }
  });
}
